import React from 'react';

import PropTypes from 'prop-types';

import Layout from '../Layout/Layout';

import styles from './PageSection.scss';

function PageSection(props) {
    const {
        children,
        className = '',
        layoutClassName = '',
        useNewBreakpoints = false,
        ...otherProps
    } = props;

    return (
        <section id={`${otherProps['aria-labelledby']}-section`}>
            <div
                className={className}
                {...otherProps}
            >
                <Layout className={`${layoutClassName} ${styles.layout}`} useNewBreakpoints={useNewBreakpoints}>
                    {children}
                </Layout>
            </div>
        </section>
    );
}

PageSection.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    layoutClassName: PropTypes.string,
    useNewBreakpoints: PropTypes.bool,
};

export default PageSection;
